import Vue from 'vue';
import Amplify from 'aws-amplify';
import VueApollo from 'vue-apollo';
import '@/utils/adapter';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import '@/services/authorizedFetch';

import EventBus from '@/utils/EventBus';
import apolloClient from '@/plugins/apollo';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';


Vue.use(VueApollo);
const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

// Clear store and reconnect websocket link when user signs out
EventBus.$on('authState', async (state) => {
  if (state === 'SIGNED_OUT') {
    apolloProvider.defaultClient.clearStore();
    apolloProvider.defaultClient.link.subscriptionClient.close(true);
  }
});

Vue.config.productionTip = false;

Amplify.configure({
  Auth: {
    identityPoolId: 'eu-west-1:f2c4df26-edec-4aa0-982d-25979c2944c7', // (Federated Identities > Selected Identity Pool/Create new > Sample code > Select Javascript > Get AWS Credentials)
    region: 'eu-west-1', // (User pools > General Settings > Pool Id) The first part of the Pool Id us-east-1
    userPoolId: 'eu-west-1_hpZdO9xgR', // (User pools > General Settings > Pool Id)
    userPoolWebClientId: '6p9cdpl3pehqdq94hk8irq3jh', // (User pools > General Settings > App clients > App client id)
  },
});

Amplify.Logger.LOG_LEVEL = process.env.VUE_APP_LOG_LEVEL;

new Vue({
  router,
  store,
  vuetify,
  apolloProvider,
  render: (h) => h(App),
}).$mount('#app');
